import Bridge from 'local/Bridge';

export default new Bridge();
